<script>
  import { sort } from "../stores.js";
  const sortValues = [
    {
      label: "data [a-z]",
      value: "mtime|ascending",
    },
    {
      label: "data [z-a]",
      value: "mtime|descending",
    },
    {
      label: "titolo [a-z]",
      value: "title|ascending",
    },
    {
      label: "titolo [z-a]",
      value: "title|descending",
    },
  ];
</script>

<div class="d-flex align-items-center">
  <p class="m-0 flex-shrink-0 mr-2 ">ordina per</p>
  <select class="form-control" bind:value={$sort}>
    {#each sortValues as sortValue}
      <option value={sortValue.value}>{sortValue.label}</option>
    {/each}
  </select>
</div>
